import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

const  Writeups = () => {

    return(
 <Box
    component= "section"
    id="writeups"
    sx={{ bgcolor: "#161b22", py: 10 }}
  >
    <Container
      maxWidth="lg"
    >
      <Typography
        variant="h2"
        sx={{ fontFamily: "JetBrains Mono, monospace", fontSize: { xs: "32px", md: "48px" }, fontWeight: 700, color: "#ff0033", mb: 2, textAlign: "center" }}
      >
        <span
          style={{ color: "#00ffff" }}
        >
          $
        </span>
        <span
        >
           cat ctf_writeups.log
        </span>
      </Typography>
      <Typography
        variant="body1"
        sx={{ fontFamily: "Inter, sans-serif", fontSize: "16px", color: "#c9d1d9", textAlign: "center", mb: 6 }}
      >
        Documented solutions to challenging CTF problems and security research findings
      </Typography>
      <Grid
        container={true}
        spacing={3}
      >
        <Grid
          item={true}
          xs={12}
          md={6}
        >
          <Paper
            sx={{ bgcolor: "#0d1117", p: 3, border: "1px solid rgba(255, 0, 51, 0.2)", transition: "all 0.3s", "&:hover": { border: "1px solid rgba(255, 0, 51, 0.5)", boxShadow: "0 4px 20px rgba(255, 0, 51, 0.2)" } }}
          >
            <Box
              sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2 }}
            >
              <Typography
                variant="h6"
                sx={{ fontFamily: "JetBrains Mono, monospace", color: "#00ffff", fontSize: "18px" }}
              >
                HackTheBox: Celestial
              </Typography>
              <Chip
                label="INSANE"
                size="small"
                sx={{ bgcolor: "#ff0033", color: "#fff", fontFamily: "JetBrains Mono, monospace", fontWeight: 700 }}
              />
            </Box>
            <Typography
              variant="body2"
              sx={{ fontFamily: "Inter, sans-serif", color: "#c9d1d9", mb: 2, fontSize: "14px", lineHeight: 1.6 }}
            >
              Advanced Node.js deserialization exploit leading to RCE. Bypassed WAF rules and escalated privileges through kernel vulnerability.
            </Typography>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
            >
              <Box
                sx={{ display: "flex", gap: 1 }}
              >
                <Chip
                  label="Web"
                  size="small"
                  sx={{ bgcolor: "#1f2937", color: "#e6edf3", fontSize: "11px" }}
                />
                <Chip
                  label="Privesc"
                  size="small"
                  sx={{ bgcolor: "#1f2937", color: "#e6edf3", fontSize: "11px" }}
                />
              </Box>
              <Typography
                sx={{ fontFamily: "JetBrains Mono, monospace", fontSize: "12px", color: "#00ffff" }}
              >
                350 pts
              </Typography>
            </Box>
          </Paper>
        </Grid>
        <Grid
          item={true}
          xs={12}
          md={6}
        >
          <Paper
            sx={{ bgcolor: "#0d1117", p: 3, border: "1px solid rgba(255, 0, 51, 0.2)", transition: "all 0.3s", "&:hover": { border: "1px solid rgba(255, 0, 51, 0.5)", boxShadow: "0 4px 20px rgba(255, 0, 51, 0.2)" } }}
          >
            <Box
              sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2 }}
            >
              <Typography
                variant="h6"
                sx={{ fontFamily: "JetBrains Mono, monospace", color: "#00ffff", fontSize: "18px" }}
              >
                TryHackMe: Buffer Overflow Prep
              </Typography>
              <Chip
                label="HARD"
                size="small"
                sx={{ bgcolor: "#ff6b00", color: "#fff", fontFamily: "JetBrains Mono, monospace", fontWeight: 700 }}
              />
            </Box>
            <Typography
              variant="body2"
              sx={{ fontFamily: "Inter, sans-serif", color: "#c9d1d9", mb: 2, fontSize: "14px", lineHeight: 1.6 }}
            >
              Classic stack-based buffer overflow exploitation. Developed custom shellcode and bypassed ASLR using ROP chains.
            </Typography>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
            >
              <Box
                sx={{ display: "flex", gap: 1 }}
              >
                <Chip
                  label="Binary"
                  size="small"
                  sx={{ bgcolor: "#1f2937", color: "#e6edf3", fontSize: "11px" }}
                />
                <Chip
                  label="Exploit Dev"
                  size="small"
                  sx={{ bgcolor: "#1f2937", color: "#e6edf3", fontSize: "11px" }}
                />
              </Box>
              <Typography
                sx={{ fontFamily: "JetBrains Mono, monospace", fontSize: "12px", color: "#00ffff" }}
              >
                250 pts
              </Typography>
            </Box>
          </Paper>
        </Grid>
        <Grid
          item={true}
          xs={12}
          md={6}
        >
          <Paper
            sx={{ bgcolor: "#0d1117", p: 3, border: "1px solid rgba(255, 0, 51, 0.2)", transition: "all 0.3s", "&:hover": { border: "1px solid rgba(255, 0, 51, 0.5)", boxShadow: "0 4px 20px rgba(255, 0, 51, 0.2)" } }}
          >
            <Box
              sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2 }}
            >
              <Typography
                variant="h6"
                sx={{ fontFamily: "JetBrains Mono, monospace", color: "#00ffff", fontSize: "18px" }}
              >
                PicoCTF: Cryptography Master
              </Typography>
              <Chip
                label="MEDIUM"
                size="small"
                sx={{ bgcolor: "#ffaa00", color: "#000", fontFamily: "JetBrains Mono, monospace", fontWeight: 700 }}
              />
            </Box>
            <Typography
              variant="body2"
              sx={{ fontFamily: "Inter, sans-serif", color: "#c9d1d9", mb: 2, fontSize: "14px", lineHeight: 1.6 }}
            >
              Multi-stage cryptographic challenge involving RSA weakness exploitation and custom cipher breaking using frequency analysis.
            </Typography>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
            >
              <Box
                sx={{ display: "flex", gap: 1 }}
              >
                <Chip
                  label="Crypto"
                  size="small"
                  sx={{ bgcolor: "#1f2937", color: "#e6edf3", fontSize: "11px" }}
                />
                <Chip
                  label="Math"
                  size="small"
                  sx={{ bgcolor: "#1f2937", color: "#e6edf3", fontSize: "11px" }}
                />
              </Box>
              <Typography
                sx={{ fontFamily: "JetBrains Mono, monospace", fontSize: "12px", color: "#00ffff" }}
              >
                180 pts
              </Typography>
            </Box>
          </Paper>
        </Grid>
        <Grid
          item={true}
          xs={12}
          md={6}
        >
          <Paper
            sx={{ bgcolor: "#0d1117", p: 3, border: "1px solid rgba(255, 0, 51, 0.2)", transition: "all 0.3s", "&:hover": { border: "1px solid rgba(255, 0, 51, 0.5)", boxShadow: "0 4px 20px rgba(255, 0, 51, 0.2)" } }}
          >
            <Box
              sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2 }}
            >
              <Typography
                variant="h6"
                sx={{ fontFamily: "JetBrains Mono, monospace", color: "#00ffff", fontSize: "18px" }}
              >
                CTFTime: SQL Injection Deep Dive
              </Typography>
              <Chip
                label="HARD"
                size="small"
                sx={{ bgcolor: "#ff6b00", color: "#fff", fontFamily: "JetBrains Mono, monospace", fontWeight: 700 }}
              />
            </Box>
            <Typography
              variant="body2"
              sx={{ fontFamily: "Inter, sans-serif", color: "#c9d1d9", mb: 2, fontSize: "14px", lineHeight: 1.6 }}
            >
              Advanced blind SQL injection with time-based techniques. Extracted database schema and admin credentials through automated script.
            </Typography>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
            >
              <Box
                sx={{ display: "flex", gap: 1 }}
              >
                <Chip
                  label="Web"
                  size="small"
                  sx={{ bgcolor: "#1f2937", color: "#e6edf3", fontSize: "11px" }}
                />
                <Chip
                  label="SQLi"
                  size="small"
                  sx={{ bgcolor: "#1f2937", color: "#e6edf3", fontSize: "11px" }}
                />
              </Box>
              <Typography
                sx={{ fontFamily: "JetBrains Mono, monospace", fontSize: "12px", color: "#00ffff" }}
              >
                220 pts
              </Typography>
            </Box>
          </Paper>
        </Grid>
        <Grid
          item={true}
          xs={12}
          md={6}
        >
          <Paper
            sx={{ bgcolor: "#0d1117", p: 3, border: "1px solid rgba(255, 0, 51, 0.2)", transition: "all 0.3s", "&:hover": { border: "1px solid rgba(255, 0, 51, 0.5)", boxShadow: "0 4px 20px rgba(255, 0, 51, 0.2)" } }}
          >
            <Box
              sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2 }}
            >
              <Typography
                variant="h6"
                sx={{ fontFamily: "JetBrains Mono, monospace", color: "#00ffff", fontSize: "18px" }}
              >
                HackTheBox: Active Directory Pwn
              </Typography>
              <Chip
                label="INSANE"
                size="small"
                sx={{ bgcolor: "#ff0033", color: "#fff", fontFamily: "JetBrains Mono, monospace", fontWeight: 700 }}
              />
            </Box>
            <Typography
              variant="body2"
              sx={{ fontFamily: "Inter, sans-serif", color: "#c9d1d9", mb: 2, fontSize: "14px", lineHeight: 1.6 }}
            >
              Full Active Directory compromise using Kerberoasting, Golden Ticket attacks, and DCSync to achieve Domain Admin privileges.
            </Typography>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
            >
              <Box
                sx={{ display: "flex", gap: 1 }}
              >
                <Chip
                  label="AD"
                  size="small"
                  sx={{ bgcolor: "#1f2937", color: "#e6edf3", fontSize: "11px" }}
                />
                <Chip
                  label="Windows"
                  size="small"
                  sx={{ bgcolor: "#1f2937", color: "#e6edf3", fontSize: "11px" }}
                />
              </Box>
              <Typography
                sx={{ fontFamily: "JetBrains Mono, monospace", fontSize: "12px", color: "#00ffff" }}
              >
                400 pts
              </Typography>
            </Box>
          </Paper>
        </Grid>
        <Grid
          item={true}
          xs={12}
          md={6}
        >
          <Paper
            sx={{ bgcolor: "#0d1117", p: 3, border: "1px solid rgba(255, 0, 51, 0.2)", transition: "all 0.3s", "&:hover": { border: "1px solid rgba(255, 0, 51, 0.5)", boxShadow: "0 4px 20px rgba(255, 0, 51, 0.2)" } }}
          >
            <Box
              sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2 }}
            >
              <Typography
                variant="h6"
                sx={{ fontFamily: "JetBrains Mono, monospace", color: "#00ffff", fontSize: "18px" }}
              >
                DEFCON CTF: Reverse Engineering
              </Typography>
              <Chip
                label="MEDIUM"
                size="small"
                sx={{ bgcolor: "#ffaa00", color: "#000", fontFamily: "JetBrains Mono, monospace", fontWeight: 700 }}
              />
            </Box>
            <Typography
              variant="body2"
              sx={{ fontFamily: "Inter, sans-serif", color: "#c9d1d9", mb: 2, fontSize: "14px", lineHeight: 1.6 }}
            >
              Reverse engineered obfuscated binary using Ghidra and IDA Pro. Identified anti-debugging techniques and extracted hidden flag.
            </Typography>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
            >
              <Box
                sx={{ display: "flex", gap: 1 }}
              >
                <Chip
                  label="Reversing"
                  size="small"
                  sx={{ bgcolor: "#1f2937", color: "#e6edf3", fontSize: "11px" }}
                />
                <Chip
                  label="Binary"
                  size="small"
                  sx={{ bgcolor: "#1f2937", color: "#e6edf3", fontSize: "11px" }}
                />
              </Box>
              <Typography
                sx={{ fontFamily: "JetBrains Mono, monospace", fontSize: "12px", color: "#00ffff" }}
              >
                300 pts
              </Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  </Box>

    );
};

export default Writeups;